import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import { requestContentPages } from "~/store/resource/resourceAction";
import { Delpath } from "~/utils/constants";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PrivacyPolicyPage = Loadable({
  loader: () => import("~/components/desktop/pages/PrivacyPolicyTest"),
  loading: LoadableLoading
});

class DetectPrivacyPolicy extends Component {
  componentDidMount() {
    const pathName = Delpath(this.props.location.pathname);
    this.props.requestContentPages(pathName);
  }

  render() {
    return (
      <React.Fragment>
        <PrivacyPolicyPage {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { ContentPages }
  } = state;
  return {
    device: type,
    ContentPages
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestContentPages: pathName => dispatch(requestContentPages(pathName)) // có
  };
};
const PrivacyPolicyHelmet = withTitle({
  component: DetectPrivacyPolicy,
  title: `${hospitalName.value} | Chính sách bảo mật`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivacyPolicyHelmet);
